import React, { useEffect, useState } from 'react'
import CommonPopupForm from './CommonPopupForm';
import { createBestOffers, fetchBestOffers, deleteBestOffers, updateBestOffers, getProducts } from '../../../services/customOffers';
import { toast } from 'react-toastify';
function BestOffers() {
  const [isOpen, setIsOpen] = useState(false);
  const [img, setImg] = useState(null);
  const [formData, setFormData] = useState({
    image: null,
    name: "",
    product: "",
    key_points: [],
    group_no: "",
    offer_price: "",
    retail_price: "",
  });
  const [besOffers, setBestOffers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState("");
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [product, setProduct] = useState([]);
  const filteredOptions = product.filter((item) =>
    item.equip_name.toLowerCase().includes(search.toLowerCase())
  );
  const fetchProducts = async () => {
    try {
      const res = await getProducts();
      // console.log(res?.data?.data?.results)
      setProduct(res?.data?.data?.results)
    } catch (error) {
      console.error(error)
    }
  };
  const getBestOffers = async () => {
    try {
      const res = await fetchBestOffers();
      // console.log(res?.data?.data)
      setBestOffers(res?.data?.data)
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchProducts();
    getBestOffers();
  }, [])
  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0]; // Corrected this line
    if (file) {
      setImg(file);
      setFormData({ ...formData, image: file }); // Update formData.image as well
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      const keyPointsArray = formData.key_points
        .split(',')
        .map(item => item.trim())
        .filter(item => item !== '');

      formDataToSend.append('key_points', JSON.stringify(keyPointsArray));
      formDataToSend.append('name', formData.name);
      formDataToSend.append('product', formData.product);
      formDataToSend.append('offer_price', formData.offer_price);
      formDataToSend.append('retail_price', formData.retail_price);
      formDataToSend.append('group_no', formData.group_no);

      if (formData.image) {
        formDataToSend.append('image', formData.image);
      }

      let response;
      if (editingId) {
        response = await updateBestOffers(editingId, formDataToSend);
      } else {
        response = await createBestOffers(formDataToSend);
      }

      if (response) {
        getBestOffers();
        setIsOpen(false);
        setImg(null);
        setFormData({
          image: null,
          product: "",
          name: "",
          key_points: [],
          group_no: "",
          offer_price: "",
          retail_price: "",
        });
        setEditingId(null);

      }
    } catch (error) {
      console.error(error);
    }
  };

  // console.log("dk", promotions);
  const handleEdit = (item) => {
    setEditingId(item.uid); // store the ID for editing
    setImg(item.image); // optional: image preview
    setFormData({
      image: null,
      name: item.name || "",
      product: item.product || "",
      group_no: item.group_no || "",
      key_points: Array.isArray(item.key_points) ? item.key_points.join(', ') : "",
      offer_price: item.offer_price || "",
      retail_price: item.retail_price || "",
    });
    setSearch(item.product_detail?.equip_name || "");
    setIsOpen(true);

  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteBestOffers(id);
      if (res) {
        toast.success("Best offer deleted successfully!");
        getBestOffers();
      }
    } catch (error) {
      console.error(error)
    }
  };

  const groupData = [
    { title: "Group One", data: besOffers?.group_1 },
    { title: "Group Two", data: besOffers?.group_2 },
    { title: "Group Three", data: besOffers?.group_3 },
    { title: "Group Four", data: besOffers?.group_4 },
    { title: "Group Five", data: besOffers?.group_5 },
  ];

  return (
    <>

      <div className='flex items-center justify-between my-6'>
        <h1 className='font-bold text-3xl'>Best Offers</h1>
        <button
          className="bg-[#019c89] text-white px-4 py-2 rounded"
          onClick={() => setIsOpen(true)}
        >
          Add 
        </button>
      </div>

      {groupData.map((group, i) => (
        group.data?.length > 0 && (
          <div
            key={i}
            className={`mb-10 p-5 rounded-2xl ${group.title === "Group One" ? "bg-blue-50" :
                group.title === "Group Two" ? "bg-green-50" :
                  group.title === "Group Three" ? "bg-yellow-50" :
                    group.title === "Group Four" ? "bg-red-50" : "bg-purple-50"
              }`}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-6">{group.title}</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {group.data.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-3xl shadow-lg border border-gray-200 hover:shadow-xl hover:border-blue-400 transition-all duration-300 transform hover:scale-[1.02] flex flex-col"
                >
                  <img
                    src={item.image}
                    alt="Product"
                    className="w-full h-48 object-cover rounded-t-3xl"
                  />

                  <div className="p-5 flex flex-col justify-between flex-1">
                    {/* Top Info */}
                    <div>
                      <h2 className="text-xl font-bold text-gray-800 mb-1 line-clamp-2">
                        {item.name}
                      </h2>
                      <p className="text-sm text-gray-600 mb-3">
                        {item.product_detail?.equip_name}
                      </p>

                      <div className="flex justify-between text-sm mb-3">
                        <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
                          Retail: ₹{item.retail_price}
                        </span>
                        <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full">
                          Offer: ₹{item.offer_price}
                        </span>
                      </div>

                      <div className="mb-4">
                        <p className="text-sm font-semibold text-gray-700 mb-1">Key Points:</p>
                        <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 max-h-[100px] overflow-y-auto scrollbar-thin scrollbar-thumb-blue-300 pr-1">
                          {item.key_points?.map((point, idx) => (
                            <li key={idx}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-end space-x-2 pt-4 mt-auto">
                      <button
                        onClick={() => handleEdit(item)}
                        className="px-4 py-2 text-sm text-white bg-gradient-to-r from-blue-500 to-blue-700 rounded-full hover:from-blue-600 hover:to-blue-800 transition"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(item.uid)}
                        className="px-4 py-2 text-sm text-white bg-gradient-to-r from-red-500 to-red-700 rounded-full hover:from-red-600 hover:to-red-800 transition"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      ))}



      <CommonPopupForm
        title="Add Promotions"
        isOpen={isOpen}
        // onClose={() => setIsOpen(false)}
        onClose={() => {
          setIsOpen(false);
          setEditingId(null);
          setImg(null);
          setSearch(""); // Reset search query
          setIsSelectOpen(false); // Close dropdown
          setFormData({
            image: null,
            name: "",
            product: "",
            key_points: [],
            group_no: "",
            offer_price: "",
            retail_price: "",

          });
        }}
        onSubmit={handleSubmit}
      >
        {/* Scrollable content container */}
        <div className="space-y-6 overflow-y-auto max-h-[65vh] px-4 py-2">

          {/* Image Upload */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700"> Image</label>
            <input
              type="file"
              name="image"
              onChange={handleImage}
              accept="image/*"
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
            />
            {img && (
              <img
                src={typeof img === 'string' ? img : URL.createObjectURL(img)}
                alt="Preview"
                className="w-32 h-32 object-cover mt-2 rounded border"
              />
            )}
          </div>

          {/* Grid Inputs */}
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="space-y-2 relative">
              <label className="block text-sm font-medium text-gray-700">Product</label>
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setIsSelectOpen(true);
                }}
                onFocus={() => setIsSelectOpen(true)}
                placeholder="Search product"
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              />
              {isSelectOpen && (
                <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-auto">
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((item) => (
                      <li
                        key={item.uid}

                        onClick={() => {
                          setSearch(item.equip_name);
                          setFormData(prev => ({
                            ...prev,
                            product: item.uid                 // Set actual UID to send
                          }));
                          setIsSelectOpen(false);
                          // update stock_no or any other field
                        }}
                        className="px-4 py-2 cursor-pointer hover:bg-[#019c89] hover:text-white text-sm"
                      >
                        {item.equip_name}
                      </li>
                    ))
                  ) : (
                    <li className="px-4 py-2 text-gray-500 text-sm">No results found</li>
                  )}
                </ul>
              )}
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Key Points</label>
              <input
                type="text"
                name="key_points"
                value={formData.key_points} // Show as comma-separated string
                onChange={handleChange}
                placeholder="Key Points (comma separated)"
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Offer Price</label>
              <input
                type="number"
                name="offer_price"
                value={formData.offer_price}
                onChange={handleChange}
                placeholder="Min %"
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Retail Price</label>
              <input
                type="number"
                name="retail_price"
                value={formData.retail_price}
                onChange={handleChange}
                placeholder="Min %"
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Group Number</label>
              <select
                name="group_no"
                value={formData.group_no}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#019c89]"
              >
                <option value="" disabled>Select group number</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>

              </select>
            </div>
          </div>
        </div>
      </CommonPopupForm>
    </>
  )
}

export default BestOffers
